import { render, staticRenderFns } from "./JetlagInfo.vue?vue&type=template&id=1c77f608&scoped=true&"
import script from "./JetlagInfo.vue?vue&type=script&lang=ts&"
export * from "./JetlagInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c77f608",
  null
  
)

export default component.exports